import React, { useState } from 'react';

import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { SentimentSatisfiedAlt } from '@mui/icons-material';
import { Popover } from '@mui/material';

import Button from 'domains/core/components/Button';

type EmojiData = {
    native: string;
    id?: string;
    name?: string;
    colons?: string;
    unified?: string;
};

type Props = {
    handleSelect: (emoji: string) => void;
};

const EmojiPicker = ({ handleSelect }: Props) => {
    // Popup anchors
    const [emojiAnchorEl, setEmojiAnchorEl] = useState<HTMLButtonElement | null>(null);

    // Event handlers
    const handleEmojiButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setEmojiAnchorEl(event.currentTarget);
    };

    const handleEmojiSelect = (emoji: EmojiData) => {
        handleSelect(emoji.native);
        setEmojiAnchorEl(null);
    };

    const handleEmojiPickerClose = () => setEmojiAnchorEl(null);

    return (
        <>
            <Button
                color="primary"
                onClick={handleEmojiButtonClick}
                startIcon={<SentimentSatisfiedAlt />}
                sx={{ height: 'auto', padding: '4px 8px 4px 12px' }}
                variant="text"
            >
                Emoji
            </Button>
            <Popover
                open={Boolean(emojiAnchorEl)}
                anchorEl={emojiAnchorEl}
                onClose={handleEmojiPickerClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Picker data={data} onEmojiSelect={handleEmojiSelect} theme="light" previewPosition="none" />
            </Popover>
        </>
    );
};

export default EmojiPicker;
